import DuvidasFrequentes from 'components/__ASSOCIADO__/DuvidasFrequentes';
import Context from 'pages/Associado/AssembleiaAssociado/Context';
import React, { useContext } from 'react';

import './styles.scss';

interface ModalContainerProps {
  id?: string;
  onCancel?: () => void;
  show: boolean;
  onClick?: any;
}

const AssembleiaChatModal: React.FC<ModalContainerProps> = ({
  id = 'modal',
  show,
  onCancel = () => {},
}) => {
  const { currentEvent, usuario } = useContext(Context);

  const handleOutsideClick = (e: any) => {
    if (e.target.id === id) {
      onCancel();
    }
  };

  return (
    <>
      {show && (
        <div id={id} className={`overlay active`} onClick={handleOutsideClick}>
          <div className={'modalChat'}>
            <DuvidasFrequentes
              isModal={true}
              onClick={() => onCancel()}
              evento={currentEvent!}
              associado={usuario!}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AssembleiaChatModal;
